<template>
  <InputText
    allowedChars="a-zA-Z0-9 \-àÀâÂèÈêÊéÉëËïÏîÎôÔùÙûÛçÇ"
    :label="label"
    :icon="icon"
    :identifier="identifier"
    :initialValue="initialValue"
    :validations="computedValidations"
    :informationTooltipContent="informationTooltipContent"
    :forcedValidations="forcedValidations"
    @onChange="data => $emit('onChange', data)"
    @onInput="data => $emit('onInput', data)"
  />
</template>

<script>
import InputText from "./InputText.vue";
/**
 * @description Contrôle pour l'input pour un nom
 * @author Samuel Dubé
 * @vue-prop {String} initialValue - Valeur initiale de la saisie
 * @vue-prop {String} identifier - Identifiant de l'input
 * @vue-prop {String} label - Étiquette affichée pour l'input
 * @vue-prop {String} icon - Icône affichée pour l'input
 * @vue-prop {String} informationTooltipContent - Le message à afficher pour le tooltip d'information (null pour qu'il n'y en est pas)
 * @vue-prop {Number} forcedValidations - Nombre de validations forcées (les validations sont exécutées lorsque la valeur change)
 * @vue-computed {Array} computedValidations - Retourne toutes les validations à effectuer
 */
export default {
  name: "InputTextName",
  components: {
    InputText
  },
  props: {
    initialValue: {
      type: String,
      required: false,
      default: ""
    },
    identifier: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: "user"
    },
    informationTooltipContent: {
      type: String,
      required: false,
      default: null
    },
    forcedValidations: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    computedValidations() {
      return [
        {
          error: this.$i18n.t("errors.empty", { name: this.label }),
          exec: v => v !== ""
        },
        {
          error: this.$i18n.t("errors.charsNotAllowed"),
          exec: v => /^[^#!$%'()*+/:;<>?@[\]\\^{}|`~*]{0,100}$/.test(v)
        }
      ];
    }
  }
};
</script>
